import { clearLogin, saveAppConfig, saveLogin } from "./auth-storage";

const authReducer = (state, action) => {
  switch (action.type) {
    case "USER_LOGIN":
      saveLogin(
        action.payload.token,
        action.payload.user,
        action.payload.tenant
      );
      return {
        ...state,
        token: action.payload.token,
        user: action.payload.user,
        tenant: action.payload.tenant,
        appConfig: null,
        configStatus: "idle",
        configError: null,
        moduleNotice: null,
      };

    case "CONFIG_LOADING":
      return {
        ...state,
        configStatus: "loading",
        configError: null,
      };

    case "CONFIG_SUCCESS":
      saveAppConfig(action.payload.tenantCode, action.payload.appConfig);
      return {
        ...state,
        appConfig: action.payload.appConfig,
        configStatus: "ready",
        configError: null,
      };

    case "MODULE_DISABLED": {
      const appConfig =
        state.appConfig && action.payload?.moduleKey
          ? {
              ...state.appConfig,
              features: {
                ...state.appConfig.features,
                modules: {
                  ...state.appConfig.features?.modules,
                  [action.payload.moduleKey]: false,
                },
              },
            }
          : state.appConfig;
      if (appConfig && action.payload?.moduleKey) {
        saveAppConfig(action.payload.tenantCode, appConfig);
      }

      return {
        ...state,
        appConfig,
        moduleNotice:
          action.payload?.message ??
          "This feature has been disabled for the current tenant.",
      };
    }

    case "CLEAR_MODULE_NOTICE":
      return {
        ...state,
        moduleNotice: null,
      };

    case "CONFIG_FAILURE":
      if (action.payload?.clearSession) {
        clearLogin();
      }
      return {
        ...state,
        token: action.payload?.clearSession ? null : state.token,
        user: action.payload?.clearSession ? null : state.user,
        tenant: action.payload?.clearSession ? null : state.tenant,
        appConfig: null,
        configStatus: "error",
        configError: action.payload?.message ?? "Unable to load tenant config",
        moduleNotice: null,
      };

    case "USER_LOGOUT":
      clearLogin();
      return {
        ...state,
        token: null,
        user: null,
        tenant: null,
        appConfig: null,
        configStatus: "idle",
        configError: null,
        moduleNotice: null,
      };

    default:
      return state;
  }
};

export default authReducer;
